// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UpdateRefundInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /payroll/update_refund/{id}
 *
 * Validates input for updating a pending refund request.
 * All fields are optional - partial updates are supported.
 */
import { registerContract } from './validate'

export interface Payroll_UpdateRefundInput {
title?: string
description?: string
amount?: number
blob_name?: string
expense_date?: string
}

registerContract('Payroll_UpdateRefundInput', {
  title:        { type: 'string',  required: false },
  description:  { type: 'string',  required: false },
  amount:       { type: 'number',  required: false },
  blob_name:    { type: 'string',  required: false },
  expense_date: { type: 'string',  required: false },
})
